import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CronOptions } from '@cron-builder';
import { translate } from '@ngneat/transloco';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { AlertError, AlertSuccess } from '../../store/actions/shared.actions';
import { MasterTables } from '../../models/masters/mastertables.class';

import {
    IntegrationConfigField,
    IntegrationsSubSection,
    IntegrationSubSectionRecord,
    IntegrationTabStructure,
} from '../../interface/integrationmodal.interface';
import { AppIntegrationRecord } from '../../models/integrations/appintegrationrecord.class';
import { IntegrationsUtilsService } from '../../services/integrations-utils/integrations-utils.service';
import { UtilsService } from '../../services/utils/utils.service';

@Component({
    selector: 'app-integration-sub-sections',
    templateUrl: './integration-sub-sections.component.html',
    styleUrls: ['./integration-sub-sections.component.scss'],
    standalone: false,
})
export class IntegrationSubSectionsComponent implements OnInit, OnChanges {
    @Input() tab: IntegrationTabStructure;
    @Input() subSections: IntegrationsSubSection[];
    @Input() record: AppIntegrationRecord;
    @Input() subSectionRecord: IntegrationSubSectionRecord;
    @Input() inConnectorsUI = false;
    @Input() sources: { id: string; displayName: string; value?: string | boolean; pushValue?: string }[] = [];
    @Input() masterTables: MasterTables[];
    @Input() subTenants: any[];
    @Input() masterTableColumns: any[];
    @Input() readonly = false;

    @Output() checkDisableUpdateAndRunNow = new EventEmitter();
    @Output() testConnection = new EventEmitter();
    @Output() apiConfigChange = new EventEmitter();
    @Output() configNameChanged = new EventEmitter();
    @Output() getMasterColumns = new EventEmitter();
    @Output() chainChanged: EventEmitter<IntegrationConfigField['value']> = new EventEmitter();
    @Output() appChanged: EventEmitter<IntegrationConfigField['value']> = new EventEmitter();
    @Output() transformationsChanged: EventEmitter<IntegrationConfigField['value']> = new EventEmitter();
    @Output() checkValidateButton = new EventEmitter<boolean>();

    public cronOptions: CronOptions = {
        formInputClass: 'form-control cron-editor-input',
        formSelectClass: 'form-control cron-editor-select',
        formRadioClass: 'cron-editor-radio',
        formCheckboxClass: 'cron-editor-checkbox',
        defaultTime: '10:00:00',
        use24HourTime: true,
        hideMinutesTab: false,
        hideHourlyTab: false,
        hideDailyTab: false,
        hideWeeklyTab: false,
        hideMonthlyTab: false,
        hideYearlyTab: false,
        hideOnceTab: false,
        hideAdvancedTab: true,
        hideSeconds: true,
        removeSeconds: true,
        removeYears: true,
    };
    private unsubscribe = new Subject<void>();

    constructor(protected _integrationUtils: IntegrationsUtilsService, private _libUtils: UtilsService, private store$: Store) {}

    hideField = this._integrationUtils.hideField;
    hideSubSection = this._integrationUtils.hideSubSection;

    public addNewSubSectionRecord = (subSection: IntegrationsSubSection) =>
        this._integrationUtils.addNewSubSectionRecord(this.record as any, subSection);

    public deleteSubRecord = (records: IntegrationSubSectionRecord[], index: number) => {
        if (records && records.length > 1) {
            records.splice(index, 1);
        } else {
            this._libUtils.alertError(this.translateMsg('Atleast one configuration is required'));
        }
    };

    public canShowTestConnection = (subSectionRecord: IntegrationSubSectionRecord) => {
        const integrationField = subSectionRecord?.fields.find(field => field.id === 'integrationMethod');
        return integrationField?.value !== 'EMAIL' && integrationField?.value !== 'RESTAPI';
    };

    private translateMsg = (msg: string): string => translate('' + msg);

    public getFieldValue = (record: IntegrationSubSectionRecord, fieldId: string) => {
        return record?.fields?.find(f => f.id === fieldId)?.value;
    };

    /**
     * Copies the provided text to clipboard
     * @param text The text to copy
     */
    public copyToClipboard(text: string): void {
        if (!text) return;
        const tempElement = document.createElement('div');
        tempElement.innerHTML = text;
        const cleanText = tempElement.textContent || tempElement.innerText || '';

        navigator.clipboard.writeText(cleanText).then(
            () => {
                this.store$.dispatch(
                    AlertSuccess({
                        message: translate('Copied to clipboard'),
                    })
                );
            },
            _err => {
                this.store$.dispatch(
                    AlertError({
                        message: translate('Failed to copy'),
                    })
                );
            }
        );
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes?.openWidget) {
            // this.openWidget = changes.openWidget.currentValue;
        }
    }

    ngOnInit() {}
    ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
